import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { ChangeUser } from './ChangePendingUserStatus';
import { getUserByPhoneApi } from '../../utils/apisConsts';

const ChangePendingUserStatus: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get Company',
            content: <GetInfo apiLink={getUserByPhoneApi} />,
            id: 0,
        },

        {
            title: 'Change Pending User Company',
            content: <ChangeUser />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};
 
export default ChangePendingUserStatus;
